import { action, Action } from 'typesafe-actions'

import { Banco, DadosBancariosTypes, GetBancosPayload } from './types'

export const bancosRequest = (payload: GetBancosPayload): Action =>
  action(DadosBancariosTypes.BANCOS_REQUEST, payload)

export const bancosSuccess = (payload: Banco[] | null): Action =>
  action(DadosBancariosTypes.BANCOS_SUCCESS, payload)

export const setBancosError = (): Action => action(DadosBancariosTypes.SET_BANCOS_ERROR)

export const setBancoSelecionado = (payload: string | number | undefined): Action =>
  action(DadosBancariosTypes.SET_BANCO_SELECIONADO, payload)

export const setTipoConta = (payload: string | number | undefined): Action =>
  action(DadosBancariosTypes.SET_TIPO_CONTA, payload)

export const setTipoCreditoInss = (payload: string | number | undefined): Action =>
  action(DadosBancariosTypes.SET_TIPO_CREDITO_INSS, payload)

export const setAgencia = (payload: string): Action =>
  action(DadosBancariosTypes.SET_AGENCIA, payload)

export const setContaDadosBancarios = (payload: string): Action =>
  action(DadosBancariosTypes.SET_CONTA_DADOS_BANCARIOS, payload)

export const setDigito = (payload: string): Action =>
  action(DadosBancariosTypes.SET_DIGITO, payload)

export const clearAccountFields = (): Action => action(DadosBancariosTypes.CLEAR_ACCOUNT_FIELDS)

export const setIsBankAccountEditable = (payload: boolean): Action =>
  action(DadosBancariosTypes.SET_IS_BANK_ACCOUNT_EDITABLE, payload)

export const setBancosLoading = (payload: boolean): Action =>
  action(DadosBancariosTypes.SET_BANCOS_LOADING, payload)

export const setBancoNome = (payload: string | undefined): Action =>
  action(DadosBancariosTypes.SET_BANCO_NOME, payload)
